/**
 * @generated SignedSource<<27d14ac7e4e7c9e25540abd1b17c09dc>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
type leadSnippet_lead$fragmentType = any;
export type PoisFilters = {|
  bbox?: ?$ReadOnlyArray<?number>,
  completed_in?: ?$ReadOnlyArray<?boolean>,
  endDate?: ?string,
  id_eq?: ?string,
  mostRecent?: ?boolean,
  nextActivity?: ?$ReadOnlyArray<?string>,
  placeId?: ?string,
  saleHorizon_in?: ?$ReadOnlyArray<?string>,
  startDate?: ?string,
  status_in?: ?$ReadOnlyArray<?string>,
  useRequalifiedIfAvailable?: ?boolean,
|};
export type PoiMapDrawerLeadsQuery$variables = {|
  count: number,
  filters?: ?PoisFilters,
|};
export type PoiMapDrawerLeadsQuery$data = {|
  +pois: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +lat: ?number,
        +lng: ?number,
        +properties: $ReadOnlyArray<{|
          +id: string,
          +lead: ?{|
            +$fragmentSpreads: leadSnippet_lead$fragmentType,
          |},
        |}>,
      |},
    |}>,
  |},
|};
export type PoiMapDrawerLeadsQuery = {|
  response: PoiMapDrawerLeadsQuery$data,
  variables: PoiMapDrawerLeadsQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referrer",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PoiMapDrawerLeadsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PoiConnection",
        "kind": "LinkedField",
        "name": "pois",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoiEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Poi",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Lead",
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "leadSnippet_lead"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PoiMapDrawerLeadsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PoiConnection",
        "kind": "LinkedField",
        "name": "pois",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoiEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Poi",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Lead",
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalOpenToOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalSellingWith",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalMarketTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalNextStep",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalMonthlyGrossRent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalPerceivedValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalSeparationNextStep",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalInheritanceNextStep",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "saleHorizon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalPerception",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "buyHorizon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ownership",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "relationship",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgageTerm",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgageBuyingStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgageStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "receivedMortgageOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Property",
                            "kind": "LinkedField",
                            "name": "property",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "countryCode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PropertyType",
                                "kind": "LinkedField",
                                "name": "propertyType",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "formattedLocality",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "livingSurface",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "builtSurface",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "landSurface",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfRooms",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfBedrooms",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfResidentialUnits",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "residentialSurface",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "residentialYearlyRentalIncome",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "parkingYearlyRentalIncome",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfCommercialUnits",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commercialSurface",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commercialYearlyRentalIncome",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "incomeIncludesParking",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plotNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Appraisal",
                                "kind": "LinkedField",
                                "name": "latestAppraisal",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RealadvisorAppraisal",
                                    "kind": "LinkedField",
                                    "name": "realadvisor",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "min",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "max",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "requalifiedAt",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LeadStage",
                            "kind": "LinkedField",
                            "name": "stage",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Pipeline",
                                "kind": "LinkedField",
                                "name": "pipeline",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "leadType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "referringDomain",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "landingPageUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completed",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userCanViewLeadDetails",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalPropertyUsage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalPropertyOccupied",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgagePropertyValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgagePropertyUsage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgageIsConstruction",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgageMortgageType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mortgageReportType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MortgageAnalysis",
                            "kind": "LinkedField",
                            "name": "mortgageAnalysis",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maxPropertyValue",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GoogleAddress",
                            "kind": "LinkedField",
                            "name": "mortgageGoogleAddress",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appraisalPropertyFormattedAddress",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d429902f0e6122e3c3355fd80ea7b7ed",
    "id": null,
    "metadata": {},
    "name": "PoiMapDrawerLeadsQuery",
    "operationKind": "query",
    "text": "query PoiMapDrawerLeadsQuery(\n  $count: Int!\n  $filters: PoisFilters\n) {\n  pois(first: $count, filters: $filters) {\n    edges {\n      node {\n        id\n        lat\n        lng\n        properties {\n          id\n          lead {\n            ...leadSnippet_lead\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment leadQualificationFunnel_lead on Lead {\n  appraisalReason\n  appraisalOpenToOffer\n  appraisalSellingWith\n  appraisalMarketTime\n  appraisalNextStep\n  appraisalMonthlyGrossRent\n  appraisalPerceivedValue\n  appraisalSeparationNextStep\n  appraisalInheritanceNextStep\n  saleHorizon\n  appraisalPerception\n  buyHorizon\n  ownership\n  relationship\n  mortgageTerm\n  mortgageBuyingStatus\n  mortgageStatus\n  receivedMortgageOffer\n  property {\n    countryCode\n    propertyType {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment leadSnippet_lead on Lead {\n  ...leadQualificationFunnel_lead\n  ...leadUpdatedTimeAgo_lead\n  id\n  stage {\n    pipeline {\n      leadType\n      id\n    }\n    id\n  }\n  referrer\n  referringDomain\n  landingPageUrl\n  completed\n  userCanViewLeadDetails\n  appraisalPerceivedValue\n  appraisalPerception\n  appraisalPropertyUsage\n  relationship\n  appraisalPropertyOccupied\n  mortgagePropertyValue\n  mortgagePropertyUsage\n  mortgageIsConstruction\n  mortgageMortgageType\n  mortgageReportType\n  mortgageAnalysis {\n    maxPropertyValue\n  }\n  mortgageGoogleAddress {\n    formattedAddress\n    id\n  }\n  appraisalPropertyFormattedAddress\n  property {\n    countryCode\n    formattedAddress\n    formattedLocality\n    lat\n    lng\n    livingSurface\n    builtSurface\n    landSurface\n    numberOfRooms\n    numberOfBedrooms\n    numberOfResidentialUnits\n    residentialSurface\n    residentialYearlyRentalIncome\n    parkingYearlyRentalIncome\n    numberOfCommercialUnits\n    commercialSurface\n    commercialYearlyRentalIncome\n    incomeIncludesParking\n    plotNumber\n    propertyType {\n      label\n      name\n      id\n    }\n    latestAppraisal {\n      realadvisor {\n        min\n        max\n      }\n      id\n    }\n    id\n  }\n  contact {\n    firstName\n    lastName\n    referrer\n    id\n  }\n}\n\nfragment leadUpdatedTimeAgo_lead on Lead {\n  createdAt\n  requalifiedAt\n}\n"
  }
};
})();

(node/*: any*/).hash = "be3ab02cc215c27d1ddceaf482059448";

export default node;
